import Base from '../../../../../shared/Api';

class Api {
    static returnPlanOrder(planOrderId: number, customerReturnedMessage: string): Promise<any> {
        return new Base().post(`/views/planorder/agent/${planOrderId}/return`, {
            customerReturnedMessage: customerReturnedMessage
        });
    }
}

export default Api;
